
import { Union, Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type, class_type, record_type, list_type, string_type, bool_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ClientApiResponse$1_$reflection, RequestedValue$1_$reflection } from "../Shared/Shared.js";
import { CompletedOnboardingTourStepsDto_$reflection, OnboardingAvailable_$reflection } from "../Shared/Onboarding.js";

export class State extends Record {
    constructor(DemoImportAvailable, CompletedTourSteps, ShowRestApiTourInfoDialog) {
        super();
        this.DemoImportAvailable = DemoImportAvailable;
        this.CompletedTourSteps = CompletedTourSteps;
        this.ShowRestApiTourInfoDialog = ShowRestApiTourInfoDialog;
    }
}

export function State_$reflection() {
    return record_type("OnboardingHub.Types.State", [], State, () => [["DemoImportAvailable", RequestedValue$1_$reflection(bool_type)], ["CompletedTourSteps", RequestedValue$1_$reflection(list_type(string_type))], ["ShowRestApiTourInfoDialog", bool_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DemoImportAvailabilityFetched", "CompletedTourStepsFetched", "FetchError", "StartTourStep", "TourStepPersistResponse", "TourStepPersistFailed", "CloseRestApiTourInfoDialog"];
    }
}

export function Msg_$reflection() {
    return union_type("OnboardingHub.Types.Msg", [], Msg, () => [[["Item", OnboardingAvailable_$reflection()]], [["Item", CompletedOnboardingTourStepsDto_$reflection()]], [["Item", class_type("System.Exception")]], [["Item", string_type]], [["Item1", string_type], ["Item2", ClientApiResponse$1_$reflection(CompletedOnboardingTourStepsDto_$reflection())]], [["Item", class_type("System.Exception")]], []]);
}

